function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var LanguageZoneTemplate = require('./language-zone.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var LanguageZoneOverlay = /*#__PURE__*/function () {
  function LanguageZoneOverlay(app, mod) {
    _classCallCheck(this, LanguageZoneOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(LanguageZoneOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.visible = true;
      this.overlay.show(LanguageZoneTemplate());
      this.attachEvents(mycallback);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var lzo = this;
      var obj = document.querySelector('.language-zone-overlay');
      if (!obj) {
        return;
      }
      if (obj.querySelector('.english')) {
        obj.querySelector('.english').click = function (e) {
          lzo.hide();
          if (mycallback) {
            mycallback('english');
          }
        };
      }
      if (obj.querySelector('.french')) {
        obj.querySelector('.french').click = function (e) {
          lzo.hide();
          if (mycallback) {
            mycallback('french');
          }
        };
      }
      if (obj.querySelector('.german')) {
        obj.querySelector('.german').click = function (e) {
          lzo.hide();
          if (mycallback) {
            mycallback('germany');
          }
        };
      }
      if (obj.querySelector('.italian')) {
        obj.querySelector('.italian').click = function (e) {
          lzo.hide();
          if (mycallback) {
            mycallback('italian');
          }
        };
      }
      if (obj.querySelector('.spanish')) {
        obj.querySelector('.spanish').click = function (e) {
          lzo.hide();
          if (mycallback) {
            mycallback('spanish');
          }
        };
      }
    }
  }, {
    key: "showDebaters",
    value: function showDebaters() {
      var language_zone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'german';
      var committed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'uncommitted';
      var faction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'protestant';
      var his_self = this.mod;
      var obj = document.querySelector('.language-zone-overlay .debaters');
      if (obj) {
        obj.innerHTML = '';
        obj.style.display = 'flex';
      }
      for (var i = 0; i < his_self.game.state.debaters.length; i++) {
        if (his_self.game.state.debaters[i].faction == faction) {
          if (committed == 'committed' && his_self.game.state.debaters[i].committed == 1) {
            this.app.browser.addElementToSelector("<div class=\"debaters-tile debaters-tile".concat(i, " debater-commited\" data-key=\"").concat(his_self.game.state.debaters[i].key, "\" data-id=\"").concat(his_self.game.state.debaters[i].img, "\" style=\"background-image:url('/his/img/tiles/debaters/").concat(his_self.game.state.debaters[i].img, "')\"></div>"), '.language-zone-overlay .debaters');
          }
          if (committed == 'uncommitted' && his_self.game.state.debaters[i].committed != 1) {
            this.app.browser.addElementToSelector("<div class=\"debaters-tile debaters-tile".concat(i, "\" data-key=\"").concat(his_self.game.state.debaters[i].key, "\" data-id=\"").concat(his_self.game.state.debaters[i].img, "\" style=\"background-image:url('/his/img/tiles/debaters/").concat(his_self.game.state.debaters[i].img, "')\"></div>"), '.language-zone-overlay .debaters');
          }
        }
      }
    }
  }, {
    key: "hideDebaters",
    value: function hideDebaters() {
      var obj = document.querySelector('.language-zone-overlay .debaters');
      if (obj) {
        obj.style.display = 'none';
      }
    }
  }]);
}();
module.exports = LanguageZoneOverlay;